<script lang="ts" setup>
    const props = defineProps<{
        description: string,
        heading: string,
        subHeading: string,
        title: string,
        link: {
            url: string,
            title: string
        },
        image: {
            node: {
                mediaItemUrl: string,
                title: string,
                url: string,
                srcSet: string
            }
        }
    }>();
    useHead({
        link: [
            {
                href: props?.image?.node?.mediaItemUrl,
                fetchpriority: 'high',
                rel: 'preload',
                as: 'image',
            }
        ],
    });
</script>
<template>
    <div v-if="heading" class="container-xl">
        <div :class="`slider-header`">
            <h2 class="slider-title text-dark-2">{{ heading }}</h2>
            <h4 class="slider-subtitle text-primary ff-dm-sans-light mb-0">{{ subHeading }}</h4>
        </div>
    </div>
    <div class="container-fluid position-relative hero-wrapper">
        <div class="left-bg-wrapper col-md-3 h-100 position-absolute bg-green-light"/>
        <div class="container-xl d-flex flex-column flex-md-row content-wrapper">
            <div class="col-md-6 col-12 hero-image-container p-4 bg-green-light rounded-end">
                <div class="hero-image-wrapper p-md-2 p-0">
                    <NuxtImg
                        v-if="image?.node?.mediaItemUrl"
                        :src="image?.node?.mediaItemUrl"
                        class="hero-image rounded"
                        format="webp"
                        :srcset="image?.node?.srcSet"
                        :quality="80"
                        :alt="image?.node?.title"
                        width="500"
                        height="375"
                    />
                </div>
            </div>
            <div class="col-md-6 col-12 hero-content py-5 pb-md-5 pb-0">
                <div class="hero-description">
                    <h1 class="hero-title text-dark-2 w-75 mb-4" v-html="title"></h1>
                    <div v-html="description"  class="description-intro text-dark-2"></div>
                </div>
                <div class="action-div d-flex">
                    <a :href="link?.url" target="_blank" class="btn btn-secondary rounded-pill text-uppercase">
                        {{ link?.title }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>